import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { AcmType } from '../../models/loyalty-acm-type.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class LoyaltyAcmTypeService {

  private cache = new Map<string, AcmType>();
  public baseUrl = '/koncentro-loyalty/acm';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(acmtypeId): Observable <AcmType> {

    if (this.cache.has(acmtypeId)) {
      return Observable.of(this.cache.get(acmtypeId));
    }
    return this.http.getPaged(this.baseUrl + '/acm_type/' + acmtypeId ).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  list (
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
  ): Observable <{data: Array<AcmType>, metadata: ListMetadata}> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/acm_type?' + params.toString());
  }

  update(acmType: AcmType): Observable<AcmType> {
    return this.http.put(this.baseUrl + '/acm_type/' + acmType.id, acmType).map(res => {
      this.cache.delete(acmType.id);
      return res;
    });
  }

  create(acmType: AcmType): Observable<AcmType> {
    return this.http.post(this.baseUrl + '/acm_type/', acmType);
  }

  remove(acmTypeId): Observable<AcmType> {
    return this.http.delete(this.baseUrl + '/acm_type/' + acmTypeId).map(res => {
      this.cache.delete(acmTypeId);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      return res;
    });
  }

  recover(acmType) {
    return this.http.put(this.baseUrl + '/acm_type/recover/' + acmType.id, acmType)
      .map(res => {
        this.cache.delete(acmType.id);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
    }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('koncentro-loyalty/schema/AcmTypeDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getAllAcmTypes() {
    return this.http.get(this.baseUrl + '/acm_type');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-acm-type.service.ts